import React from 'react';
import { StaticPage } from 'src/domains/players/webview/components/Account/staticPage/StaticPage';
import { observer } from 'src/utils/mobx-react';

export const CustomerFundsProtection = observer('CustomerFundsProtection', ()=>{
    return <StaticPage id='customer-funds-protection' />;
});
